// extracted by mini-css-extract-plugin
module.exports = {"root":"MainComponent_root__2_D9e","main":"MainComponent_main__d3xg9"};